import type { Stripe } from '@stripe/stripe-js';
import { createContext } from 'react';

export interface AppContextProps {
  stripePromise: Promise<Stripe | null>;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);
